/**
 * Generated from PostcardRio1Layout.fla
 */
export function PostcardRio1Layout(this: IPostcardRio1Layout) {
	const main = this.main;
	PostcardRio1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardRio1Layout_main(this: IPostcardRio1Layout_main) {
	const postcard = this.postcard;
	PostcardRio1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardRio1Layout_postcard(this: IPostcardRio1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardRio1Layout_cardTransform1.call(cardTransform[0] as IPostcardRio1Layout_cardTransform1);
		cardTransform[0].x = 524.4;
		cardTransform[0].y = 438.2;
		cardTransform[0].width = 343.27;
		cardTransform[0].height = 430.27;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardRio1Layout_cardTransform2.call(cardTransform[1] as IPostcardRio1Layout_cardTransform2);
		cardTransform[1].x = -662.95;
		cardTransform[1].y = 65;
		cardTransform[1].width = 501.76;
		cardTransform[1].height = 628.95;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardRio1Layout_cardTransform3.call(cardTransform[2] as IPostcardRio1Layout_cardTransform3);
		cardTransform[2].x = -626.25;
		cardTransform[2].y = -403.75;
		cardTransform[2].width = 404.75;
		cardTransform[2].height = 507.34;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardRio1Layout_cardTransform4.call(cardTransform[3] as IPostcardRio1Layout_cardTransform4);
		cardTransform[3].x = 680.1;
		cardTransform[3].y = -291.05;
		cardTransform[3].width = 460.49;
		cardTransform[3].height = 577.22;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardRio1Layout_cardTransform5.call(cardTransform[4] as IPostcardRio1Layout_cardTransform5);
		cardTransform[4].x = -283.7;
		cardTransform[4].y = -243.1;
		cardTransform[4].width = 370.79;
		cardTransform[4].height = 464.78;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardRio1Layout_cardTransform6.call(cardTransform[5] as IPostcardRio1Layout_cardTransform6);
		cardTransform[5].x = -164.2;
		cardTransform[5].y = 213.8;
		cardTransform[5].width = 465.19;
		cardTransform[5].height = 583.11;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardRio1Layout_cardTransform7.call(cardTransform[6] as IPostcardRio1Layout_cardTransform7);
		cardTransform[6].x = 140.05;
		cardTransform[6].y = -393.3;
		cardTransform[6].width = 398.57;
		cardTransform[6].height = 499.59;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardRio1Layout_cardTransform8.call(cardTransform[7] as IPostcardRio1Layout_cardTransform8);
		cardTransform[7].x = 481.2;
		cardTransform[7].y = 68.7;
		cardTransform[7].width = 475.46;
		cardTransform[7].height = 595.97;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardRio1Layout_pieces7.call(items[0] as IPostcardRio1Layout_pieces7);
		(items[0] as IPostcardRio1Layout_pieces7).dependsOn = 0;
		(items[0] as IPostcardRio1Layout_pieces7).outlineGlow = true;
		items[0].x = 118.6;
		items[0].y = -391.65;
		items[0].width = 833.00;
		items[0].height = 475.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardRio1Layout_outlines7.call(items[1] as IPostcardRio1Layout_outlines7);
		items[1].x = 137;
		items[1].y = -417.25;
		items[1].width = 738.00;
		items[1].height = 457.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardRio1Layout_pieces3.call(items[2] as IPostcardRio1Layout_pieces3);
		items[2].x = -622.2;
		items[2].y = -407.5;
		items[2].width = 361.00;
		items[2].height = 414.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardRio1Layout_outlines3.call(items[3] as IPostcardRio1Layout_outlines3);
		items[3].x = -623.35;
		items[3].y = -407.1;
		items[3].width = 293.00;
		items[3].height = 343.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardRio1Layout_pieces5.call(items[4] as IPostcardRio1Layout_pieces5);
		items[4].x = -268.4;
		items[4].y = -289.3;
		items[4].width = 254.00;
		items[4].height = 392.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardRio1Layout_outlines5.call(items[5] as IPostcardRio1Layout_outlines5);
		items[5].x = -280.5;
		items[5].y = -196.55;
		items[5].width = 255.00;
		items[5].height = 390.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardRio1Layout_pieces8.call(items[6] as IPostcardRio1Layout_pieces8);
		items[6].x = 513;
		items[6].y = 100;
		items[6].width = 352.00;
		items[6].height = 361.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardRio1Layout_outlines8.call(items[7] as IPostcardRio1Layout_outlines8);
		items[7].x = 500.1;
		items[7].y = 70.05;
		items[7].width = 349.00;
		items[7].height = 358.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardRio1Layout_decorationRio11.call(items[8] as IPostcardRio1Layout_decorationRio11);
		items[8].x = 622.4;
		items[8].y = -174.3;
		items[8].width = 560.00;
		items[8].height = 145.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardRio1Layout_pieces4.call(items[9] as IPostcardRio1Layout_pieces4);
		items[9].x = 689.8;
		items[9].y = -256;
		items[9].width = 325.00;
		items[9].height = 404.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardRio1Layout_outlines4.call(items[10] as IPostcardRio1Layout_outlines4);
		items[10].x = 679.35;
		items[10].y = -268.35;
		items[10].width = 324.00;
		items[10].height = 405.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[11]) {
		PostcardRio1Layout_pieces1.call(items[11] as IPostcardRio1Layout_pieces1);
		(items[11] as IPostcardRio1Layout_pieces1).dependsOn = 0;
		(items[11] as IPostcardRio1Layout_pieces1).outlineGlow = true;
		items[11].x = 526.3;
		items[11].y = 442.65;
		items[11].width = 521.00;
		items[11].height = 412.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardRio1Layout_outlines1.call(items[12] as IPostcardRio1Layout_outlines1);
		items[12].x = 527.3;
		items[12].y = 445.3;
		items[12].width = 212.00;
		items[12].height = 214.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardRio1Layout_pieces2.call(items[13] as IPostcardRio1Layout_pieces2);
		items[13].x = -711.1;
		items[13].y = 40.9;
		items[13].width = 454.99;
		items[13].height = 480.99;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,undefined);
	}
	if (items[14]) {
		PostcardRio1Layout_outlines2.call(items[14] as IPostcardRio1Layout_outlines2);
		items[14].x = -635.6;
		items[14].y = 33.65;
		items[14].width = 447.00;
		items[14].height = 468.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,undefined);
	}
	if (items[15]) {
		PostcardRio1Layout_pieces6.call(items[15] as IPostcardRio1Layout_pieces6);
		items[15].x = -155.55;
		items[15].y = 224.45;
		items[15].width = 285.00;
		items[15].height = 490.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,undefined);
	}
	if (items[16]) {
		PostcardRio1Layout_outlines6.call(items[16] as IPostcardRio1Layout_outlines6);
		items[16].x = -163.05;
		items[16].y = 222.55;
		items[16].width = 284.00;
		items[16].height = 489.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	const background = this.background;
	PostcardRio1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardRio1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardRio1Layout_background(this: IPostcardRio1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-rio-1.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform7(this: IPostcardRio1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform6(this: IPostcardRio1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform5(this: IPostcardRio1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform4(this: IPostcardRio1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-4.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform3(this: IPostcardRio1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform8(this: IPostcardRio1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-8.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform1(this: IPostcardRio1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_cardTransform2(this: IPostcardRio1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-rio-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_pieces7(this: IPostcardRio1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_outlines7(this: IPostcardRio1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-7.png", 0.500, 0.501);
	return this;
}
function PostcardRio1Layout_pieces3(this: IPostcardRio1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-3.png", 0.501, 0.500);
	return this;
}
function PostcardRio1Layout_outlines3(this: IPostcardRio1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-3.png", 0.502, 0.501);
	return this;
}
function PostcardRio1Layout_pieces5(this: IPostcardRio1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-5.png", 0.547, 0.263);
	return this;
}
function PostcardRio1Layout_outlines5(this: IPostcardRio1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-5.png", 0.502, 0.500);
	return this;
}
function PostcardRio1Layout_pieces8(this: IPostcardRio1Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-8.png", 0.537, 0.582);
	return this;
}
function PostcardRio1Layout_outlines8(this: IPostcardRio1Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-8.png", 0.501, 0.500);
	return this;
}
function PostcardRio1Layout_decorationRio11(this: IPostcardRio1Layout_decorationRio11) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-rio-1-1.png", 0.571, 0.566);
	return this;
}
function PostcardRio1Layout_pieces4(this: IPostcardRio1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-4.png", 0.529, 0.530);
	return this;
}
function PostcardRio1Layout_outlines4(this: IPostcardRio1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-4.png", 0.500, 0.501);
	return this;
}
function PostcardRio1Layout_pieces1(this: IPostcardRio1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-1.png", 0.359, 0.590);
	return this;
}
function PostcardRio1Layout_outlines1(this: IPostcardRio1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_pieces2(this: IPostcardRio1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-2.png", 0.345, 0.501);
	return this;
}
function PostcardRio1Layout_outlines2(this: IPostcardRio1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-2.png", 0.501, 0.500);
	return this;
}
function PostcardRio1Layout_pieces6(this: IPostcardRio1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-rio-1-6.png", 0.526, 0.505);
	return this;
}
function PostcardRio1Layout_outlines6(this: IPostcardRio1Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-rio-1-6.png", 0.500, 0.501);
	return this;
}
function PostcardRio1Layout_postcardOverlay(this: IPostcardRio1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardRio1Layout_postcardMask(this: IPostcardRio1Layout_postcardMask) {
	return this;
}
interface IPostcardRio1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardRio1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardRio1LayoutSprite extends IPostcardRio1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardRio1LayoutText extends IPostcardRio1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardRio1LayoutPolygon extends Array<number> {
}
interface IPostcardRio1Layout {
	readonly main: IPostcardRio1Layout_main;
}
interface IPostcardRio1Layout_main extends IPostcardRio1LayoutContainer {
	readonly postcard: IPostcardRio1Layout_postcard;
}
interface IPostcardRio1Layout_postcard extends IPostcardRio1LayoutContainer {
	readonly cardTransform: IPostcardRio1LayoutArray<IPostcardRio1Layout_cardTransform1|IPostcardRio1Layout_cardTransform2|IPostcardRio1Layout_cardTransform3|IPostcardRio1Layout_cardTransform4|IPostcardRio1Layout_cardTransform5|IPostcardRio1Layout_cardTransform6|IPostcardRio1Layout_cardTransform7|IPostcardRio1Layout_cardTransform8>;
	readonly items: IPostcardRio1LayoutArray<IPostcardRio1Layout_pieces7|IPostcardRio1Layout_outlines7|IPostcardRio1Layout_pieces3|IPostcardRio1Layout_outlines3|IPostcardRio1Layout_pieces5|IPostcardRio1Layout_outlines5|IPostcardRio1Layout_pieces8|IPostcardRio1Layout_outlines8|IPostcardRio1Layout_decorationRio11|IPostcardRio1Layout_pieces4|IPostcardRio1Layout_outlines4|IPostcardRio1Layout_pieces1|IPostcardRio1Layout_outlines1|IPostcardRio1Layout_pieces2|IPostcardRio1Layout_outlines2|IPostcardRio1Layout_pieces6|IPostcardRio1Layout_outlines6>;
	readonly background: IPostcardRio1Layout_background;
	readonly postcardOverlay: IPostcardRio1Layout_postcardOverlay;
	readonly postcardMask: IPostcardRio1Layout_postcardMask;
}
interface IPostcardRio1Layout_background extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform7 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform6 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform5 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform4 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform3 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform8 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform1 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_cardTransform2 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces7 extends IPostcardRio1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio1Layout_outlines7 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces3 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines3 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces5 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines5 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces8 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines8 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_decorationRio11 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces4 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines4 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces1 extends IPostcardRio1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardRio1Layout_outlines1 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces2 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines2 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_pieces6 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_outlines6 extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_postcardOverlay extends IPostcardRio1LayoutSprite {
}
interface IPostcardRio1Layout_postcardMask extends IPostcardRio1LayoutPolygon {
}
